import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.object.freeze";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { addObj, editObj, deleteObj, getList, dictType, getAllContact, getMonitorList, getProjectAndDeviceList } from '@/api/deviceOverview/alarm';
import { dictList, user_list } from '@/api/deviceOverview/file';
export default {
  name: 'alarmSetting',
  data: function data() {
    return {
      searchVal: '',
      formLabelWidth1: '160px',
      tableData: [],
      typeList: [],
      levelList: [],
      contactList: [],
      variateOptions: [],
      type: '',
      curObj: {},
      current: 1,
      size: 10,
      total: 0,
      searchVariateOptions: [],
      devModel: '',
      form: {
        title: this.$t('alarmSetting.addAlarm'),
        dialogFormVisible: false,
        isSms: 0,
        isWeb: 0,
        formItem: {
          alarmName: '',
          alarmLevel: '',
          alarmType: '',
          threshold: '',
          monitorId: '',
          alarmContent: '',
          solution: '',
          // intervalTime:'',
          lockFlag: false,
          linkman: '',
          alarmRank: '',
          isAlarm: '',
          devModel: ''
        },
        rules: Object.freeze({
          alarmName: [{
            required: true,
            message: this.$t('alarmSetting.inputAlarmName'),
            trigger: 'blur'
          }],
          alarmType: [{
            required: true,
            message: this.$t('alarmSetting.choAlarmType'),
            trigger: 'change'
          }],
          monitorId: [{
            required: true,
            message: this.$t('alarmSetting.choAssVariable'),
            trigger: 'change'
          }],
          threshold: [{
            required: true,
            message: this.$t('alarmSetting.inputAlarmValue'),
            trigger: 'blur'
          }],
          alarmContent: [{
            required: true,
            message: this.$t('alarmSetting.inputAlarmContent'),
            trigger: 'blur'
          }] // intervalTime: [{ required: true, message: '请输入报警间隔时间', trigger: 'blur' }]

        })
      },
      column: [{
        prop: 'index',
        label: this.$t('realdetile.serNum'),
        width: 50
      }, {
        prop: 'devModelName',
        label: this.$t('manipulation.airModel')
      }, {
        prop: 'alarmName',
        label: this.$t('alarmSetting.alarmName')
      }, {
        prop: 'alarmRankName',
        label: this.$t('alarmSetting.alarmLevel')
      }, {
        prop: 'monitorName',
        label: this.$t('alarmSetting.assMonitor')
      }, {
        prop: 'alarmContent',
        label: this.$t('alarmSetting.alarmContent')
      }],
      disabled: '',
      typeList2: [],
      typeList1: [],
      typeList3: [],
      typeList4: [],
      userlist: [],
      props: {
        value: 'id',
        label: 'name',
        children: 'deviceList'
      }
    };
  },
  created: function created() {
    this.getdictList();
    this.getuserlist();
    this.queryMonitorList();
  },
  components: {},
  computed: _objectSpread({}, mapGetters(["stationObj", 'permission'])),
  methods: {
    getuserlist: function getuserlist() {
      var _this = this;

      user_list().then(function (res) {
        if (res.data.code === 200) {
          _this.userlist = res.data.data;
        }
      });
    },
    getdictList: function getdictList() {
      var _this2 = this;

      // 空调
      // getProjectAndDeviceList().then(res=>{
      //     if(res.data.code===200){
      //         this.typeList4 = res.data.data
      //     }
      // })
      dictList({
        code: "device_model"
      }).then(function (res) {
        if (res.data.code === 200) {
          _this2.typeList3 = res.data.data[0].children;
        }
      }); // 报警等级

      dictList({
        code: "alarm_rank"
      }).then(function (res) {
        if (res.data.code === 200) {
          _this2.typeList1 = res.data.data[0].children;
        }
      }); // 报警类型

      dictList({
        code: "alarm_type"
      }).then(function (res) {
        if (res.data.code === 200) {
          _this2.typeList2 = res.data.data[0].children;
        }
      });
    },
    viewHandle: function viewHandle(row1) {
      var row = JSON.parse(JSON.stringify(row1));
      this.curObj = row;
      this.type = 'edit';
      this.form.title = this.$t('alarmSetting.editAlarm');
      this.form.dialogFormVisible = true;

      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields();
      }

      this.form.isSms = Number(row.isSms);
      this.form.isWeb = Number(row.isWeb);
      this.form.formItem = row;
      this.form.formItem.monitorId = row.monitorId;
    },
    handleCurrentChange: function handleCurrentChange(cur) {
      this.current = cur;
      this.queryListPage();
    },
    search: function search() {
      this.current = 1;
      this.queryListPage();
    },
    refresh: function refresh() {
      this.current = 1;
      this.devModel = '';
      this.queryListPage();
    },
    handleChange: function handleChange() {},
    queryListPage: function queryListPage() {
      var _this3 = this;

      getList({
        current: this.current,
        size: this.size,
        devModel: this.devModel
      }).then(function (res) {
        if (res.data.code === 200) {
          res.data.data.records.map(function (item, index) {
            item.index = index + 1;
          });
          _this3.tableData = res.data.data.records;

          _this3.rendOptions(_this3.tableData);

          _this3.total = res.data.data.total;
        } else {
          _this3.$message.error(res.data.msg);

          return;
        }
      });
    },
    rendOptions: function rendOptions(data) {
      var ary = [];
      data.map(function (item) {
        var obj = {};
        obj.monitorName = item.monitorName;
        obj.monitorId = item.monitorId;
        ary.push(obj);
      });
      this.searchVariateOptions = ary;
    },
    add: function add() {
      this.form.dialogFormVisible = true;

      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields();
      }

      this.resetFormItem();
      this.type = 'add';
      this.form.title = this.$t('alarmSetting.addAlarm');
    },
    queryMonitorList: function queryMonitorList() {
      var _this4 = this;

      getMonitorList().then(function (res) {
        if (res.data.code === 200) {
          var resData = res.data.data;
          var ary = [];
          _this4.variateOptions = resData;
        } else {
          _this4.$message.error(res.data.msg);

          return;
        }
      });
    },
    handleSubmit: function handleSubmit() {
      var _this5 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var _this5$form$formItem = _this5.form.formItem,
              alarmName = _this5$form$formItem.alarmName,
              alarmLevel = _this5$form$formItem.alarmLevel,
              alarmType = _this5$form$formItem.alarmType,
              threshold = _this5$form$formItem.threshold,
              monitorId = _this5$form$formItem.monitorId,
              alarmContent = _this5$form$formItem.alarmContent,
              solution = _this5$form$formItem.solution,
              intervalTime = _this5$form$formItem.intervalTime,
              linkman = _this5$form$formItem.linkman,
              isAlarm = _this5$form$formItem.isAlarm,
              alarmRank = _this5$form$formItem.alarmRank,
              devModel = _this5$form$formItem.devModel,
              contactId = _this5$form$formItem.contactId,
              lockFlag = _this5$form$formItem.lockFlag;

          if (_this5.type == 'add') {
            addObj({
              isAlarm: isAlarm,
              linkman: linkman,
              alarmRank: alarmRank,
              isSms: _this5.form.isSms,
              isWeb: _this5.form.isWeb,
              devModel: devModel,
              alarmName: alarmName,
              alarmType: alarmType,
              threshold: threshold,
              alarmContent: alarmContent,
              solution: solution,
              monitorId: monitorId,
              lockFlag: lockFlag * 1
            }).then(function (res) {
              if (res.data.code === 200) {
                _this5.$message.success(_this5.$t('alarmSetting.addSuc'));

                _this5.form.dialogFormVisible = false;

                _this5.resetFormItem();

                _this5.queryListPage();
              } else {
                _this5.$message.error(_this5.$t('alarmSetting.addFauRepeat'));

                return;
              }
            });
          } else if (_this5.type == 'edit') {
            editObj({
              alarmId: _this5.curObj.alarmId,
              alarmName: alarmName,
              isAlarm: isAlarm,
              linkman: linkman,
              alarmRank: alarmRank,
              isSms: _this5.form.isSms,
              isWeb: _this5.form.isWeb,
              devModel: devModel,
              alarmType: alarmType,
              threshold: threshold,
              alarmContent: alarmContent,
              solution: solution,
              intervalTime: intervalTime,
              monitorId: monitorId,
              lockFlag: lockFlag * 1
            }).then(function (res) {
              if (res.data.code === 200) {
                _this5.$message.success(_this5.$t('alarmSetting.chaSuc'));

                _this5.resetFormItem();

                _this5.form.dialogFormVisible = false;

                _this5.queryListPage();
              } else {
                _this5.$message.error(_this5.$t('alarmSetting.chaFauRepeat'));

                return;
              }
            });
          }
        } else {
          _this5.$message.warning(_this5.$t('alarmSetting.fillComplete'));

          return;
        }
      });
    },
    delHandle: function delHandle(row) {
      var _this6 = this;

      this.$confirm(this.$t('alarmSetting.promptContent') + '?', this.$t('alarmSetting.prompt'), {
        type: 'warning'
      }).then(function () {
        deleteObj({
          id: row.alarmId
        }).then(function (res) {
          if (res.data.code === 200) {
            _this6.$message.success(_this6.$t('alarmSetting.deleteSuc'));

            _this6.current = 1;

            _this6.queryListPage();
          } else {
            _this6.$message.error(_this6.$t('alarmSetting.deleteFau'));
          }
        });
      }).catch(function () {});
    },
    handleClose: function handleClose() {
      this.form.dialogFormVisible = false;
    },
    resetFormItem: function resetFormItem() {
      this.form.isWeb = 0;
      this.form.isSms = 0;
      this.form.formItem = {
        alarmName: '',
        alarmLevel: '',
        alarmType: '',
        threshold: '',
        monitorId: '',
        alarmContent: '',
        solution: '',
        intervalTime: '',
        lockFlag: false
      };
    }
  },
  mounted: function mounted() {
    this.queryListPage();
  }
};